import _ from 'underscore';

import { staticTemplateProperties } from '@bingads-webui-campaign-react/ad-placement-templates';

import { getLocalizedText, getPreviewTexts } from '../common/index';

const defaultPreviewTextKeys = {
  shortHeadline: _TL_('Short headline'),
  businessName: _TL_('App name'),
};

export const transformToTemplateData = ({
  adData,
  template,
  i18n,
}) => {
  const localizedText = getLocalizedText(template, i18n);
  const carryOverProperties = _.pick(template, staticTemplateProperties);
  const {
    className,
    previewSettings,
    imagePreviewHeight,
    styleOverrides,
    logoHeight,
  } = template;

  const defaultPreviewTexts = {
    ..._.mapObject(defaultPreviewTextKeys, stringKey => i18n.getString(stringKey)),
  };
  const skipUrlValidation = previewSettings.showUrlMultiline;
  const previewTexts = getPreviewTexts({
    adData,
    skipUrlValidation,
    defaultPreviewTexts,
  });

  return {
    className,
    previewTexts,
    imagePreviewHeight,
    logoHeight,
    styleOverrides,
    ...previewSettings,
    ...localizedText,
    ...carryOverProperties,
  };
};
